export default {
  challenges:  'CHALLENGES',
  classPacks:  'CLASS_PACKS',
  memberships: 'MEMBERSHIPS',
  purchases:   'PURCHASES'
};
